import { gql } from '@apollo/client';

const GAME_ROOM_FIELDS = gql`
  fragment GameRoomMutFields on GameRoom {
    id
    code
    hostId
    status
    mode
    pack
    players {
      id
      userId
      score
      online
      user {
        id
        firstName
        lastName
      }
    }
    currentRound {
      id
      roundNumber
      status
      impostorId
      secretWord
      outcome
      clues {
        id
        playerId
        word
        order
      }
      votes {
        id
        voterId
        targetId
      }
    }
    rounds {
      id
      roundNumber
      status
      impostorId
      secretWord
      outcome
    }
  }
`;

export const CreateGameRoom = gql`
  ${GAME_ROOM_FIELDS}
  mutation CreateGameRoom($pack: String!, $mode: String!) {
    createGameRoom(pack: $pack, mode: $mode) {
      ...GameRoomMutFields
    }
  }
`;

export const JoinGameRoom = gql`
  ${GAME_ROOM_FIELDS}
  mutation JoinGameRoom($code: String!) {
    joinGameRoom(code: $code) {
      ...GameRoomMutFields
    }
  }
`;

export const StartRound = gql`
  ${GAME_ROOM_FIELDS}
  mutation StartRound($roomId: String!) {
    startRound(roomId: $roomId) {
      ...GameRoomMutFields
    }
  }
`;

export const AcknowledgeRole = gql`
  ${GAME_ROOM_FIELDS}
  mutation AcknowledgeRole($roundId: String!) {
    acknowledgeRole(roundId: $roundId) {
      ...GameRoomMutFields
    }
  }
`;

export const SubmitClue = gql`
  ${GAME_ROOM_FIELDS}
  mutation SubmitClue($roundId: String!, $word: String!) {
    submitClue(roundId: $roundId, word: $word) {
      ...GameRoomMutFields
    }
  }
`;

export const AdvanceToVoting = gql`
  ${GAME_ROOM_FIELDS}
  mutation AdvanceToVoting($roundId: String!) {
    advanceToVoting(roundId: $roundId) {
      ...GameRoomMutFields
    }
  }
`;

export const CastVote = gql`
  ${GAME_ROOM_FIELDS}
  mutation CastVote($roundId: String!, $targetId: Int!) {
    castVote(roundId: $roundId, targetId: $targetId) {
      ...GameRoomMutFields
    }
  }
`;

export const ImpostorGuess = gql`
  ${GAME_ROOM_FIELDS}
  mutation ImpostorGuess($roundId: String!, $guess: String!) {
    impostorGuess(roundId: $roundId, guess: $guess) {
      ...GameRoomMutFields
    }
  }
`;

export const LeaveGameRoom = gql`
  mutation LeaveGameRoom($roomId: String!) {
    leaveGameRoom(roomId: $roomId)
  }
`;

export const RejoinGameRoom = gql`
  ${GAME_ROOM_FIELDS}
  mutation RejoinGameRoom($roomId: String!) {
    rejoinGameRoom(roomId: $roomId) {
      ...GameRoomMutFields
    }
  }
`;

export const EndGame = gql`
  ${GAME_ROOM_FIELDS}
  mutation EndGame($roomId: String!) {
    endGame(roomId: $roomId) {
      ...GameRoomMutFields
    }
  }
`;

export const SendGameMessage = gql`
  mutation SendGameMessage($roomId: String!, $text: String, $audioUrl: String, $duration: Int) {
    sendGameMessage(roomId: $roomId, text: $text, audioUrl: $audioUrl, duration: $duration) {
      id
      roomId
      senderId
      sender {
        id
        firstName
      }
      text
      audioUrl
      duration
      sentAt
    }
  }
`;
